import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions';
import RefreshLineIcon from 'remixicon-react/RefreshLineIcon';
import useSocket from '../../../hooks/useSocket';
import { isAdmin, isAdminAgent } from '../../../helpers/commonFunction';
import SocketActions from '../../../redux/socket/actions';

const PendingCountDealer = () => {
    const dispatch = useDispatch();
    const { getPendingDprCountdealer } = dailyPlanRequestActions;
    const { dprCountResult, dprCountLoading } = useSelector((state) => state.dailyPlanRequest);
    const { tokenData } = useSelector((state) => state.auth);
    const { getPendingDPRCountForSocketList } = SocketActions;


    useSocket('Daily Plan Request Pending updated', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getPendingDPRCountForSocketList());
        }
    });


    const [showBox, setShowBox] = useState(false);

    const fetchPendingCount = () => {
        dispatch(getPendingDprCountdealer());
    };

    useEffect(() => {
        dispatch(getPendingDprCountdealer());
    }, [dispatch]);


    const dealerList = Array.isArray(dprCountResult)
        ? dprCountResult.filter(item => item && item.DealerName)
        : dprCountResult && dprCountResult.DealerName
            ? [dprCountResult]
            : [];

    return (
        <div className="row mb-3">
            <div className="col-12">
                <div className="d-flex align-items-center mb-2">
                    <input type="checkbox" checked={showBox} onChange={() => setShowBox(prev => !prev)} style={{ marginRight: '8px', cursor: 'pointer' }} />
                    <h5 style={{ fontWeight: "800" }}>Show DPR Pending Count</h5>
                </div>

                {showBox && (
                    <div className="dpr-pending-box"
                        style={{ width: '100%', maxHeight: '320px', border: '1px solid #dee2e6', borderRadius: '8px', padding: '14px', overflowY: 'auto', background: '#f8f9fa', position: 'relative' }}>
                        <RefreshLineIcon
                            onClick={fetchPendingCount}
                            style={{ cursor: 'pointer', position: 'absolute', top: '3px', right: '10px' }}
                            size={20}
                            color="#8b0303"
                            title="Refresh"
                        />

                        {dprCountLoading ? (
                            <div className="dashboard-inventory-loader" style={{ marginTop: '30px', textAlign: 'center' }} >
                                <span className="spinner-border spinner-border-lg" role="status" />
                            </div>
                        ) : dealerList.length > 0 ? (
                            <div
                                style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '14px', marginTop: '10px' }}
                            >
                                {dealerList.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{ background: '#ffffff', border: '1px solid #e1e1e1', borderRadius: '8px', padding: '12px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}
                                    >
                                        <div
                                            style={{ fontSize: '13px', color: '#3f414d', marginBottom: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: '600' }}
                                            title={item?.DealerName || ''} > {item?.DealerName}
                                        </div>

                                        <div style={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'right', color: '#dc3545' }} >
                                            {item?.PendingCount ?? 0}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p style={{ marginTop: '30px', textAlign: 'center', color: '#8b0303', fontWeight: '600' }} >
                                No pending data found
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PendingCountDealer;
